module.exports = __webpack_public_path__ + "img/weather-dust.ba48771f.png";